let showHideOptions = val => {
    if ($(`select[name='interests_interest_a[property_kind]'] option[value='${val}']:selected`).length > 0) {
        hideOption($(`select[name='interests_interest_a[property_kind]'] option[value='${val}']:not(:selected)`));
    } else {
        showOption($(`select[name='interests_interest_a[property_kind]'] option[value='${val}']:not(:selected)`));
    }
};

$(document).on('turbo:load turbo:render interests:added interests:destroyed', () => {
    showHideOptions('Principal Home');
    showHideOptions('Designated Second Home');
});

$(document).on('input change', "#interests [name='interests_interest_a[property_kind]']",  () => {
    showHideOptions('Principal Home');
    showHideOptions('Designated Second Home');
});


let showOption = function(val) {
    val.each(function () {
        if (this.tagName == "OPTION") {
            var opt = this;
            if ($(this).parent().get(0).tagName == "SPAN") {
                var span = $(this).parent().get(0);
                $(span).replaceWith(opt);
                $(span).remove();
            }
            opt.disabled = false;
            $(opt).show();
        }
    });
};

let hideOption = function(val) {
    val.each(function() {
        if( this.tagName == "OPTION" ) {
            var opt = this;
            if( $(this).parent().get(0).tagName == "SPAN" ) {
                var span = $(this).parent().get(0);
                $(span).hide();
            } else {
                $(opt).wrap("span").hide();
            }
            opt.disabled = true;
        }
    });
};